import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { PricingCTA } from '../components/PricingCTA';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function SalesPage() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (!window.fbq) {
      const n = window.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      } as any;
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    // Initialize and track PageView
    window.fbq('init', '1772423723450218');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen bg-[#05080f] text-white selection:bg-blue-500/30 selection:text-blue-200" data-id="element-180">
      <Hero data-id="element-181" />
      <ProblemSection data-id="element-182" />
      <SolutionSection data-id="element-183" />
      <WhatYouGet data-id="element-184" />
      <PricingCTA data-id="element-185" />

      {/* Simple Footer */}
      <footer className="py-8 bg-[#020305] border-t border-white/5 text-center text-gray-600 text-sm" data-id="element-186">
        <div className="container mx-auto px-4" data-id="element-187">
          <p data-id="element-188">
            © {new Date().getFullYear()} Explosive Baseball Power System. All
            rights reserved.
          </p>
        </div>
      </footer>

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-189">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1772423723450218&ev=PageView&noscript=1" alt="" data-id="element-190" />
      </noscript>
    </main>;
}